import React from 'react';
import { string } from 'prop-types';
import { Translate } from 'react-localize-redux';
import VariableRadarSummary from '../VariableRadarSummary';
import { surveyStatsType } from '../../constants/types';
import VariableSummary from '../VariableSummary';
import { AVAILABLE_LANGUAGES } from '../../constants';
import { sortVariableStatisticsByType } from '../../util';
import { getTranslation } from '../../i18n';

import styles from './surveyVariableSummary.module.css';

const SurveyVariableSummary = ({ surveyStats, lang }) => {
  const variableStatistics = sortVariableStatisticsByType(surveyStats.variableStatistics);

  return (
    <div>
      <section>
        <h2><Translate id="surveySummary.summaryHeading" /></h2>

        <div
          dangerouslySetInnerHTML={// eslint-disable-line react/no-danger
            { __html: getTranslation(surveyStats.feedbackIntroduction, lang) }
          }
        />

        <div className={styles.radarContainer} data-cy="variable-radar-summary">
          <VariableRadarSummary
            variableStats={variableStatistics}
          />
        </div>
      </section>

      { variableStatistics.map((v) => (
        <VariableSummary stats={v} key={getTranslation(v.name, AVAILABLE_LANGUAGES[0])} />
      )) }
    </div>
  );
};

SurveyVariableSummary.propTypes = {
  surveyStats: surveyStatsType.isRequired,
  lang: string.isRequired
};

export default SurveyVariableSummary;
